import React from 'react';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

import PriorityIcon from '@lmt/unicorn-shared/app/icons/small-tick.svg?react';
import styles from './ExpandedPatientForm.module.scss';

export const PriorityBadge: React.FC = () => {
  const i18next = useScopedTranslation('patients.form.fields');
  return (
    <div className={styles.priorityContainer}>
      <PriorityIcon className={styles.priorityIcon} />
      <div className={styles.priorityText}>{i18next.t('priority_contact')}</div>
    </div>
  );
};
